import axios from '@/axios'
import CONFIG from '@/config'

/**
 * 根据类目查找商品
 * @param {object} obj
 * @returns
 */
export function getProductByCatalog (catalogCode) {
  return axios.post('ssg/mall/product/get-product-by-code', {
    appCode: CONFIG.APP_CODE,
    code: catalogCode
  })
}
/**
 * 商城下单
 * @param {object} obj
 * @returns
 */
export function placeOrder (data) {
  return axios.post('ssg/mall/order/place-order', {
    appCode: CONFIG.APP_CODE,
    apkVersion: CONFIG.VERSION,
    clientAddress: '',
    ...data
  })
}
/**
 * 根据订单号获取订单详情
 * @param {object} obj
 * @returns
 */
export function getOrderByNo (orderNo) {
  return axios.post('ssg/mall/order/get-order-status-by-no', {
    orderNo
  })
}
